import gql from 'graphql-tag';

export const ListAdditionalTaskItemQuery = gql`
  query ListAdditionalTaskItemQuery {
    additionalTaskItems{
      stageCode
      name
        programTypeCode
      }
  }
`;


